import { IToastConfig } from 'src/common/primitives/Toast';

export function generateSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `An attendant profile has been added!`,
  };
}
